import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toast";
//import * as auth from "../Auth";
import axios from "axios";
import ScaleLoader from "react-spinners/ScaleLoader";
import { useTranslation, withTranslation } from "react-i18next";
import styled from "styled-components";
import Uploady, { useItemProgressListener } from "@rpldy/uploady";
import { getMockSenderEnhancer } from "@rpldy/mock-sender";
import UploadButton from "@rpldy/upload-button";
import UploadPreview from "@rpldy/upload-preview";
import ImageUploader from "react-images-upload";
import "./style.css";
import PersonaInformation from "./PersonaInformation";
import PersonaInformation2 from "./PersonaInformation2";
import Preference from "./Preference";
import Security from "./Security";

import {
  CreditCardIcon,
  KeyIcon,
  UserCircleIcon,
  UserGroupIcon,
  ViewGridAddIcon,
  LockClosedIcon,
} from "@heroicons/react/outline";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");

function Parametres(props) {
  const { t } = useTranslation("common");
  var navigation = [
    { id: 0, name: "Profil", href: "#", icon: UserCircleIcon, current: true },
    { id: 1, name: "Appel entrant", href: "#", icon: KeyIcon, current: false },
    {
      id: 2,
      name: "Préference",
      href: "#",
      icon: CreditCardIcon,
      current: false,
    },
  ];

  const [black1, changeColor1] = useState(
    "w-48 bg-gray-50 dark:bg-gray-800 text-green-700 hover:text-green-700  dark:hover:bg-gray-800 hover:bg-white group rounded-md px-3 py-2 flex items-center text-sm font-medium"
  );
  const [black11, changeColor11] = useState(
    "text-green-500 group-hover:text-green-500 flex-shrink-0 -ml-1 mr-3 h-5 w-5"
  );
  const [black2, changeColor2] = useState(
    "w-48 text-gray-900 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800  hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium"
  );
  const [black3, changeColor3] = useState(
    "w-48 text-gray-900 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800  hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium"
  );
  const [black4, changeColor4] = useState(
    "w-48 text-gray-900 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800  hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium"
  );
  const [loading, setloading] = useState("Profil");
  function setnavigation1(item) {
    setloading(item);
    changeColor3(
      "w-48 text-gray-900 dark:hover:bg-gray-800 dark:text-gray-300  hover:text-gray-900 hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium"
    );
    changeColor2(
      "w-48 text-gray-900 dark:hover:bg-gray-800 hover:text-gray-900 dark:text-gray-300 hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium"
    );
    changeColor1(
      "w-48 bg-gray-50 dark:hover:bg-gray-800  dark:bg-gray-800 text-green-700 hover:text-green-700 hover:bg-white group rounded-md px-3 py-2 flex items-center text-sm font-medium"
    );
    changeColor4(
      "w-48 text-gray-900 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800  hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium"
    );
  }

  function setnavigation2(item) {
    setloading(item);
    changeColor3(
      "w-48 text-gray-900 dark:hover:bg-gray-800 dark:text-gray-300 hover:text-gray-900 hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium"
    );
    changeColor1(
      "w-48 text-gray-900 dark:hover:bg-gray-800 dark:text-gray-300 hover:text-gray-900 hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium"
    );
    changeColor2(
      "w-48 bg-gray-50 dark:hover:bg-gray-800  dark:bg-gray-800 text-green-700 hover:text-green-700 hover:bg-white group rounded-md px-3 py-2 flex items-center text-sm font-medium"
    );
    changeColor4(
      "w-48 text-gray-900 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800  hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium"
    );
  }
  function setnavigation3(item) {
    setloading(item);
    changeColor2(
      "w-48 text-gray-900 dark:hover:bg-gray-800 dark:text-gray-300 hover:text-gray-900 hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium"
    );
    changeColor1(
      "w-48 text-gray-900 dark:hover:bg-gray-800 dark:text-gray-300 hover:text-gray-900 hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium"
    );
    changeColor3(
      "w-48 bg-gray-50 dark:hover:bg-gray-800 dark:bg-gray-800 text-green-700 hover:text-green-700 hover:bg-white group rounded-md px-3 py-2 flex items-center text-sm font-medium"
    );
    changeColor4(
      "w-48 text-gray-900 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800  hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium"
    );
  }
  function setnavigation4(item) {
    setloading(item);
    changeColor3(
      "w-48 text-gray-900 dark:hover:bg-gray-800 dark:text-gray-300  hover:text-gray-900 hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium"
    );
    changeColor2(
      "w-48 text-gray-900 dark:hover:bg-gray-800 hover:text-gray-900 dark:text-gray-300 hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium"
    );
    changeColor1(
      "w-48 text-gray-900 dark:hover:bg-gray-800 hover:text-gray-900 dark:text-gray-300 hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium"
    );
    changeColor4(
      "w-48 bg-gray-50 dark:hover:bg-gray-800  dark:bg-gray-800 text-green-700 hover:text-green-700 hover:bg-white group rounded-md px-3 py-2 flex items-center text-sm font-medium"
    );
  }

  useEffect(() => {}, [loading]);

  return (
    <div className="lg:grid lg:grid-cols-12 bg-gray-200 dark:bg-gray-700">
      <aside className="dark:text-green-700 ml-4 py-6 px-2 sm:px-6 lg:py-0 lg:px-0 lg:col-span-2 ">
        <nav className="space-y-1 mt-8">
          <button onClick={() => setnavigation1("Profil")} className={black1}>
            <UserCircleIcon className={black11} aria-hidden="true" />
            <span className="truncate">{t("parametres.profil")}</span>
          </button>
          <button
            onClick={() => setnavigation2("Transfert d'appel")}
            className={black2}
          >
            <svg
              class={black11}
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="random"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              data-fa-i2svg=""
            >
              <path
                fill="currentColor"
                d="M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
              ></path>
            </svg>
            <span className="truncate">
              {t("parametres.renvoi'appel.titre")}
            </span>
          </button>
          <button
            onClick={() => setnavigation3("Préferences")}
            className={black3}
          >
            <ViewGridAddIcon className={black11} aria-hidden="true" />
            <span className="truncate">{t("parametres.preference.titre")}</span>
          </button>
          <button onClick={() => setnavigation4("security")} className={black4}>
            <LockClosedIcon className={black11} aria-hidden="true" />
            <span className="truncate">{t("paramtres.tittre.security")}</span>
          </button>
        </nav>
      </aside>
      <div className="space-y-6 sm:px-6 lg:px-0 lg:col-span-10 bg-gray-200">
        <div className="min-h-screen bg-white flex dark:bg-gray-800 ">
          <div className="flex-1 flex  justify-center  pt-4 pl-4 dark:bg-gray-700 bg-gray-200 ">
            {/* <PersonaInformation></PersonaInformation> */}
            {loading == "Profil" ? (
              <PersonaInformation></PersonaInformation>
            ) : (
              <div></div>
            )}
            {loading == "Transfert d'appel" ? (
              <PersonaInformation2
              // toggle={props.location.state.fromDashboard()}
              ></PersonaInformation2>
            ) : (
              <div></div>
            )}
            {loading == "Préferences" ? <Preference></Preference> : <div></div>}
            {loading == "security" ? <Security></Security> : <div></div>}
          </div>
        </div>
      </div>
    </div>
  );
}
export default withTranslation("common")(Parametres);
